// Fase 5: the official experiences catalog lives in the database (Admin → Experiências)
// and is served via GET /api/experiences — see data/catalog.js. Migration validated 1:1
// against the former static source (backend/tests/test_experiences.py, zero data loss).
// Only display metadata below remains static.
export const ISLANDS = ['Todos', 'São Tomé', 'Príncipe', 'Santiago'];

export const FEATURED_SLUGS = [
  'north-tour-cocoa-route',
  'wild-south-pico-cao-grande',
  'discover-principe',
  'principe-by-sea',
  'authentic-northern-santiago',
  'serra-malagueta-vale-principal-trek',
];
